import React from "react";
import Tooltip from "components/Global/Tooltip";

const LanguageInfo = ({ field }) => {
  const languages = field?.languages
    ? field?.languages.filter(l => l.enabled)
    : [];
  const hasLanguages =
    ["text", "textarea", "wysiwyg"].includes(field?.type) && languages.length;

  if (!hasLanguages) {
    return <></>;
  }

  return (
    <>
      <Tooltip
        placement="right"
        tooltip={languages.map(l => l.language).join(", ")}
      >
        <span
          style={{
            borderLeft: "1px solid #ccc",
            paddingLeft: "3px",
            marginLeft: "5px",
            height: "13px"
          }}
        >
          <span
            style={{
              fontSize: "13px",
              color: "#777"
            }}
            className="material-icons"
          >
            public
          </span>
        </span>
      </Tooltip>
    </>
  );
};

export default LanguageInfo;
